import { render, staticRenderFns } from "./VetroSpinner.vue?vue&type=template&id=c81e2d60&scoped=true"
import script from "./VetroSpinner.vue?vue&type=script&lang=ts"
export * from "./VetroSpinner.vue?vue&type=script&lang=ts"
import style0 from "./VetroSpinner.vue?vue&type=style&index=0&id=c81e2d60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c81e2d60",
  null
  
)

export default component.exports